// apps/hatid/app/_lib/productQueries.js
// export async function fetchKuyaJProducts({ branchId = 1, category = "all" }) {
//   const params = new URLSearchParams({
//     branchId: String(branchId),
//     category,
//   });

//   const res = await fetch(`/api/partner/kuya-j/products?${params}`, {
//     cache: "no-store",
//   });

//   if (!res.ok) {
//     const text = await res.text();
//     throw new Error(`Partner products failed: ${res.status} ${text}`);
//   }
//   return await res.json(); // { data, total }
// }

// app/_lib/data/productQueries.js (Hatid)
export async function fetchKuyaJProducts({
  branchId,
  q = "",
  category = "all",
  order = "selling_price.desc",
}) {
  // Consturcts the URL
  const url = new URL("/api/partner/kuya-j/products", window.location.origin);

  // Consturct URL Params req
  url.searchParams.set("branchId", String(branchId));
  if (q) url.searchParams.set("q", q);
  if (category) url.searchParams.set("category", category);
  if (order) url.searchParams.set("order", order);

  const res = await fetch(url.toString(), { cache: "no-store" });
  if (!res.ok) {
    const msg = await res.text();
    throw new Error(`Partner products failed: ${res.status} ${msg}`);
  }
  return res.json(); // { data, total }
}

export async function fetchKuyaJProductById(productId) {
  const res = await fetch(`/api/partner/kuya-j/product/${productId}`, {
    cache: "no-store",
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Partner products failed: ${res.status} ${text}`);
  }
  return await res.json(); // { data, total }
}
